<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar toolbar-dense">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Ecommerce Products">Ecommerce Products</span>
      </div>

      <!-- Center: Store selector + Filters + Search + Labels toggle + Actions -->
      <div class="app-toolbar-center">
        <!-- Ecommerce store selector -->
        <ng-container *ngIf="ecommerceConnections && ecommerceConnections.length > 1">
          <div class="toolbar-store-select">
            <mat-icon class="toolbar-store-icon">store</mat-icon>
            <span class="toolbar-btn-label toolbar-store-label" i18n="@@Store">Store</span>
            <select class="toolbar-native-select"
                    [ngModel]="selectedEcommerceConnectionId"
                    (ngModelChange)="onStoreSelectChange($event)"
                    i18n-title="@@Select Ecommerce Store" title="Select Ecommerce Store">
              <option value="ALL" i18n="@@All Stores">All Stores</option>
              <!-- `storeLabel` -- see EcommerceConnection.storeLabel: several stores of one type per organization is normal. -->
              <option *ngFor="let ec of ecommerceConnections" [value]="ec.ID">{{ ec.type | languageString }} {{ ec.storeLabel }} - {{ ( organizationService && organizationService.objectsById['' + ec.org_ID]) ? organizationService.objectsById['' + ec.org_ID].name : 'Org ' + ec.org_ID }}</option>
            </select>
          </div>
        </ng-container>

        <div class="toolbar-divider"></div>

        <!-- Filter toggles -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ALL')" (click)="toggleFilter('ALL')" i18n-title="@@All" title="All">
            <mat-icon>filter_list</mat-icon><span class="toolbar-btn-label" i18n="@@All">All</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('CONNECTED')" (click)="toggleFilter('CONNECTED')" i18n-title="@@Connected" title="Connected">
            <mat-icon>check_circle</mat-icon><span class="toolbar-btn-label" i18n="@@Connected">Connected</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('NEED_REMOTE_PRODUCT')" (click)="toggleFilter('NEED_REMOTE_PRODUCT')" i18n-title="@@Need Remote Product" title="Need Remote Product">
            <mat-icon>warning</mat-icon><span class="toolbar-btn-label" i18n="@@Need Remote Product">Need Remote Product</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ARCHIVED_PRODUCT')" (click)="toggleFilter('ARCHIVED_PRODUCT')" i18n-title="@@Archived Product" title="Archived Product">
            <mat-icon>unpublished</mat-icon><span class="toolbar-btn-label" i18n="@@Archived Product">Archived Product</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('ERROR')" (click)="toggleFilter('ERROR')" i18n-title="@@Error" title="Error">
            <mat-icon>error</mat-icon><span class="toolbar-btn-label" i18n="@@Error">Error</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('NEED_PRODUCT')" (click)="toggleFilter('NEED_PRODUCT')" i18n-title="@@Need Product" title="Need Product">
            <mat-icon>compare_arrows</mat-icon><span class="toolbar-btn-label" i18n="@@Need Product">Need Product</span>
          </button>
          <button class="toolbar-filter" [class.active]="selectedFilters.value.includes('IGNORED')" (click)="toggleFilter('IGNORED')" i18n-title="@@Ignored" title="Ignored">
            <mat-icon>cancel</mat-icon><span class="toolbar-btn-label" i18n="@@Ignored">Ignored</span>
          </button>
        </div>

        <!-- Show/Hide Labels standalone toggle -->
        <button class="toolbar-filter-standalone" [class.active]="showSymbolMeanings" (click)="showSymbolMeanings=!showSymbolMeanings" [title]="showSymbolMeanings ? 'Hide Labels' : 'Show Labels'">
          <mat-icon>{{ showSymbolMeanings ? 'label' : 'label_off' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Search -->
        <div class="toolbar-search">
          <mat-icon>search</mat-icon>
          <input type="text" (keyup)="onSearchInputChange($event)" i18n-placeholder="@@Search" placeholder="Search">
        </div>

        <div class="toolbar-divider"></div>

        <!-- Actions -->
        <div class="toolbar-actions">
          <button *ngIf="selectedEcommerceConnection && selectedEcommerceConnection.type !== 'CSV'" class="toolbar-action toolbar-action-primary" (click)="readRemoteProducts($event)" i18n-title="@@Read Remote Products" title="Read Remote Products">
            <mat-icon>cloud_download</mat-icon><span class="toolbar-btn-label" i18n="@@Read Remote Products">Read Remote Products</span>
          </button>
        </div>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="ecommerceproducts"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="pageArea">
          <div class="mainProductsArea">

            <!-- templates used by both the table and the narrow stacked div element versions -->
            <ng-template #idTemplate let-row>
              <div>{{row.ID}}</div>
            </ng-template>

            <ng-template #ecommerceConnectionTemplate let-row>
              <ng-container *ngIf="row.ecommerceConnection">
                <div>{{ row.ecommerceConnection?.type | languageString }} {{row.ecommerceconnection_ID}}</div>
                <div *ngIf="row.ecommerceConnection"><span *ngIf="showSymbolMeanings">{{ 'Organization' | languageString }}:&nbsp;</span>{{ row.ecommerceConnection?.org_ID }}: {{ ( organizationService && organizationService.objectsById['' + row.ecommerceConnection?.org_ID]) ? organizationService.objectsById['' + row.ecommerceConnection?.org_ID]?.name : '' }}</div>
              </ng-container>
              <ng-container *ngIf="!row.ecommerceConnection">
                <div *ngIf="row.product"><span *ngIf="showSymbolMeanings">{{ 'Organization' | languageString }}:&nbsp;</span>{{ row.product.org_ID }}: {{ ( organizationService && organizationService.objectsById['' + row.product?.org_ID]) ? organizationService.objectsById['' + row.product?.org_ID]?.name : '' }}</div>
              </ng-container>
            </ng-template>

            <ng-template #remoteProductTemplate let-row>
              <span *ngIf="row.remoteproduct_ID === ''" style="color: red" i18n="@@No remote product">No remote product</span>
              <span *ngIf="row.remoteproduct_ID !== ''">{{ row.remoteproduct_ID }}<span *ngIf="row.remoteTitle !== ''">: {{ row.remoteTitle }}</span></span>
            </ng-template>

            <ng-template #productTemplate let-row>
              <span *ngIf="row.product_ID === 0" style="color: red" i18n="@@No Product Selected">No Product Selected</span>
              <span *ngIf="row.product_ID !== 0">{{ row.product_ID }}<span *ngIf="row.product">: {{ row.product.title }}</span><span *ngIf="row.productStatus === 'ARCHIVED'"> - <span style="color: red" i18n="@@Archived Product">Archived Product</span></span></span>
            </ng-template>

            <ng-template #remoteChangeTypeTemplate let-row>
              <span *ngIf="showSymbolMeanings">{{ row.remoteChangeType | languageString }}</span>
              <mat-icon *ngIf="row.remoteChangeType === 'INSERT'" style="color: green">add_circle</mat-icon>
              <mat-icon *ngIf="row.remoteChangeType === 'UPDATE'" style="color: black">compare_arrows</mat-icon>
              <mat-icon *ngIf="row.remoteChangeType === 'REMOVE'" style="color: darkorange">delete</mat-icon>
            </ng-template>

            <ng-template #remoteUpdateStatusTemplate let-row>
              <span *ngIf="showSymbolMeanings">{{ row.remoteUpdateStatus | languageString }}</span>
              <mat-icon *ngIf="row.remoteUpdateStatus === 'SENT'" style="color: green">done_all</mat-icon>
              <mat-icon *ngIf="row.remoteUpdateStatus === 'ERROR'" style="color: red">cloud_off</mat-icon>
              <mat-icon *ngIf="row.remoteUpdateStatus === 'WAITING'" style="color: darkorange">hourglass_empty</mat-icon>
              <mat-icon *ngIf="row.remoteUpdateStatus === 'RECEIVED'" style="color: blue">assignment_turned_in</mat-icon>
            </ng-template>

            <ng-template #remoteTimestampTemplate let-row>
              <span *ngIf="Util.isValidTime(row.remoteTimestamp)">{{ row.remoteTimestamp | date: 'MM/dd/yy HH:mm' }}</span>
            </ng-template>

            <ng-template #changeTypeTemplate let-row>
              <span *ngIf="showSymbolMeanings">{{ row.changeType | languageString }}</span>
              <mat-icon *ngIf="row.changeType === 'INSERT'" style="color: green">add_circle</mat-icon>
              <mat-icon *ngIf="row.changeType === 'UPDATE'" style="color: black">compare_arrows</mat-icon>
              <mat-icon *ngIf="row.changeType === 'REMOVE'" style="color: darkorange">delete</mat-icon>
            </ng-template>

            <ng-template #updateStatusTemplate let-row>
              <span *ngIf="showSymbolMeanings">{{ row.updateStatus | languageString }}</span>
              <mat-icon *ngIf="row.updateStatus === 'SENT'" style="color: green">done_all</mat-icon>
              <mat-icon *ngIf="row.updateStatus === 'ERROR'" style="color: red">cloud_off</mat-icon>
              <mat-icon *ngIf="row.updateStatus === 'WAITING'" style="color: darkorange">hourglass_empty</mat-icon>
              <mat-icon *ngIf="row.updateStatus === 'RECEIVED'" style="color: blue">assignment_turned_in</mat-icon>
            </ng-template>

            <ng-template #updateTimestampTemplate let-row>
              <span *ngIf="Util.isValidTime(row.updateTimestamp)">{{ row.updateTimestamp | date: 'MM/dd/yy HH:mm' }}</span>
            </ng-template>

            <ng-template #detailsTemplate let-row>
              <button mat-icon-button (click)="toggleExpandCollapse(row)">
                <mat-icon>{{selectedEcommerceProduct === row ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
              </button>
            </ng-template>

            <ng-template #actionsTemplate let-row>
              <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && ( row.remoteUpdateStatus === '' || row.remoteUpdateStatus === 'WAITING' || row.remoteUpdateStatus === 'ERROR' )" mat-icon-button (click)="publishToRemoteServer(row, $event)" i18n-title="@@Release Order">
                <mat-icon>send</mat-icon>
              </button>
              <button *ngIf="row.ignoreStatus==='NOT_IGNORE' && ( row.remoteUpdateStatus === 'SENT' )" mat-icon-button (click)="publishToRemoteServer(row, $event)" i18n-title="@@Release Order">
                <mat-icon>refresh</mat-icon>
              </button>
<!--              <ng-container *ngIf="row.releaseStatus !== 'SUCCESS'">-->
                <button *ngIf="row.ignoreStatus==='NOT_IGNORE'" mat-icon-button (click)="setIgnoretatus(row, 'IGNORE', $event)" i18n-title="@@Ignore this order">
                  <mat-icon>cancel</mat-icon>
                </button>
                <button *ngIf="row.ignoreStatus==='IGNORE'" mat-icon-button (click)="setIgnoretatus(row, 'NOT_IGNORE', $event)" i18n-title="@@Cancel ignore this order">
                  <mat-icon>check_circle</mat-icon>
                </button>
<!--              </ng-container>-->
            </ng-template>

            <ng-template #detailsDisplayedTemplate let-element>
              <ng-container *ngIf="selectedEcommerceProduct === element">
                <button *ngIf="!selectProduct" mat-flat-button color="primary" (click)="selectProduct = true; compareProductListingDetails = false;">
                  <span i18n="@@Select Product">Select Product</span>
                </button>
                <button *ngIf="!selectProduct && !compareProductListingDetails" mat-flat-button color="primary" (click)="compareProductListingDetails = true; selectProduct = false;">
                  <span i18n="@@Compare Product Listing Details">Compare Product Listing Details</span>
                </button>
                <div *ngIf="selectProduct">
                  <div *ngIf="itemSelectionData.product && selectProduct" style="margin-bottom: 0px">
                    <h5 style="margin-bottom: 0px" i18n="@@Selected Product">Selected Product</h5>
                    <span *ngIf="itemSelectionData.product">{{itemSelectionData.product.title}}</span><button class="floatStart" style="background-color: transparent; border: none" *ngIf="itemSelectionData.product" i18n-title="@@UnSetTheSelectedProduct" title="Clear the selected product" (click)="itemSelectionData.setProduct(undefined)"><mat-icon>close</mat-icon></button>
                  </div>
                  <div *ngIf="itemSelectionData && itemSelectionData.possibleMatches && itemSelectionData.possibleMatches.length > 0">
                    <h5 style="margin-bottom: 0px" i18n="@@Best Matches">Best Matches</h5>
                    <mat-chip-listbox>
                      <mat-chip-option [selected]="possibleMatch.product === itemSelectionData.product" *ngFor="let possibleMatch of itemSelectionData.getBestPossibleMatches( 6 )" (click)="itemSelectionData.setProduct(possibleMatch.product)" [style.background-color]="getBackgroundColor(possibleMatch.matches / itemSelectionData.maxPossibleMatchIntersections )" [style.--mdc-chip-label-text-color]="getColor(possibleMatch.matches / itemSelectionData.maxPossibleMatchIntersections )" style="height: auto;">{{ possibleMatch.product?.ID }} - {{possibleMatch.product?.title}}</mat-chip-option>
                    </mat-chip-listbox>
                  </div>
                  <div>
                    <mat-select style="width: 70%; padding-top: 8px;" #productId i18n-placeholder="@@Select a product" placeholder="Select a product" [ngModel]="itemSelectionData.product" (selectionChange)="itemSelectionData.setProduct(productId.value)" [ngModelOptions]="{standalone: true}">
                      <mat-select-trigger>
                        <mat-form-field appearance="fill" style="width: 100%;">
                          <input matInput #searchInput i18n-placeholder="@@Search products" placeholder="Search products" (input)="onSearch(searchInput.value)">
                          <button mat-icon-button *ngIf="searchInput.value" matSuffix (click)="clearSearch($event)">
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-form-field>
                      </mat-select-trigger>
                      <mat-option [class.selected]="!itemSelectionData.product" [value]="undefined" i18n="@@No Product Selected">No Product Selected</mat-option>
                      <mat-option [class.selected]="itemSelectionData.product && itemSelectionData.product === product" *ngFor="let product of productsInSelectedEcommerceConnection" [value]="product">{{product.title}}</mat-option>
                    </mat-select>
                    <!--                -->
                    <!--                <mat-select style="width: 70%; padding-top: 8px;" #productId i18n-placeholder="@@Select a product" placeholder="Select a product" [ngModel]="itemSelectionData.product" (selectionChange)="itemSelectionData.setProduct(productId.value); verifyAllProductsAreMapped()" [ngModelOptions]="{standalone: true}">-->
                    <!--                  <mat-select-trigger>-->
                    <!--                    <mat-form-field appearance="fill" style="width: 100%;">-->
                    <!--                      <input matInput #searchInput placeholder="Search products" (input)="onSearch(searchInput.value)">-->
                    <!--                      <button mat-icon-button *ngIf="searchInput.value" matSuffix (click)="clearSearch($event)">-->
                    <!--                        <mat-icon>close</mat-icon>-->
                    <!--                      </button>-->
                    <!--                    </mat-form-field>-->
                    <!--                  </mat-select-trigger>-->
                    <!--                  <mat-option [class.selected]="itemSelectionData.product && itemSelectionData.product === product" *ngFor="let product of filteredProducts" [value]="product">{{product.ID}} - {{product.title}}</mat-option>-->
                    <!--                </mat-select>-->
                  </div>
                  <button mat-icon-button (click)="saveProductEdit(element, $event.target); selectProduct = !selectProduct" [disabled]="!isProductEditDirty" i18n-title="@@Save Changes">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button (click)="cancelProductEdit(element); selectProduct = !selectProduct" i18n-title="@@Cancel Edit">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
                <div *ngIf="compareProductListingDetails">
                  <h3 i18n="@@Product Listings">Product Listings</h3>
                  <div>
                    <app-product [product1]="getProductObjectFromRaw(selectedEcommerceProduct)" [product2]="selectedEcommerceProduct.product ? selectedEcommerceProduct.product : (selectedEcommerceProduct.product_ID ? productService.objectsById[selectedEcommerceProduct.product_ID] : undefined )" [isEditingAnOption]="true" [heading1]="( selectedEcommerceProduct.ecommerceConnection.type | languageString ) + ( 'Product Listing' | languageString )" [heading2]="( 'System Listing' | languageString )"></app-product>
                  </div>
                </div>
              </ng-container>
            </ng-template>

            <!-- Narrow screen version -- no table but stacked div elements -->
            <div class="stackedProducts" *ngIf="mobileQuery.matches">
              <div *ngFor="let row of dataSource.data" class="stackedProduct"  [style.background-color]="getRowBackgroundColor(row)">
                <div class="group" data-label="Id" i18n-data-label="@@Id">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="idTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Ecommerce Connection" i18n-data-label="@@Ecommerce Connection">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="ecommerceConnectionTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Remote Product" i18n-data-label="@@Remote Product">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="remoteProductTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Product" i18n-data-label="@@Product">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="productTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Remote Change Type" i18n-data-label="@@Remote Change Type">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="remoteChangeTypeTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Remote Update Status" i18n-data-label="@@Remote Update Status">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="remoteUpdateStatusTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Remote Last Updated" i18n-data-label="@@Remote Last Updated">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="remoteTimestampTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Change Type" i18n-data-label="@@Change Type">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="changeTypeTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Update Status" i18n-data-label="@@Update Status">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="updateStatusTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Last Updated" i18n-data-label="@@Last Updated">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="updateTimestampTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                </div>
                <div class="group" data-label="Details" i18n-data-label="@@Details">
                  <div class="content">
                    <ng-container *ngTemplateOutlet="detailsTemplate; context: { $implicit: row }"></ng-container>
                  </div>
                  <div *ngIf="selectedEcommerceProduct === row">
                    {{ row.ID }}
                  </div>
                </div>
                <div class="actions">
                  <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
                </div>

              </div>
            </div>

            <!-- Wide screen version -- use a table -->
            <div class="ordersTable" *ngIf="!mobileQuery.matches">
              <table mat-table [dataSource]="dataSource" class="full-width-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Id">Id</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="id-cell">
                      <ng-container *ngTemplateOutlet="idTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container *ngIf="ecommerceConnections && ecommerceConnections.length > 1" matColumnDef="ecommerceConnection">
                  <th mat-header-cell *matHeaderCellDef><span i18n="@@Ecommerce Connection">Ecommerce Connection</span></th>
                  <td mat-cell *matCellDef="let row">
                    <div class="ecommerce-connection-cell">
                      <ng-container *ngTemplateOutlet="ecommerceConnectionTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remoteProduct">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Remote Product">Remote Product</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="remote-product-cell">
                      <ng-container *ngTemplateOutlet="remoteProductTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="product">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Product">Product</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="product-cell">
                      <ng-container *ngTemplateOutlet="productTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remoteChangeType">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Remote Change Type">Remote Change Type</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="update-status-cell">
                      <ng-container *ngTemplateOutlet="remoteChangeTypeTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remoteUpdateStatus">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Remote Update Status">Remote Update Status</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="update-status-cell">
                      <ng-container *ngTemplateOutlet="remoteUpdateStatusTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remoteTimestamp">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Remote Last Updated">Remote Last Updated</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="update-status-cell">
                      <ng-container *ngTemplateOutlet="remoteTimestampTemplate; context: { $implicit: row }"></ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="changeType">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Change Type">Change Type</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="changeTypeTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="updateStatus">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Update Status">Update Status</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="updateStatusTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="updateTimestamp">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Last Updated">Last Updated</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="updateTimestampTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="details">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Details">Details</th>
                  <td mat-cell *matCellDef="let row">
<!--                    <button mat-icon-button (click)="toggleExpandCollapse(row)">-->
<!--                      <mat-icon>{{selectedEcommerceProduct === row ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>-->
<!--                    </button>-->
                    <ng-container *ngTemplateOutlet="detailsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef i18n="@@Actions">Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: row }"></ng-container>
                  </td>
                </ng-container>

<!--                <ng-container matColumnDef="remoteChangeType">-->
<!--                  <th mat-header-cell *matHeaderCellDef i18n="@@Change Type">Change Type</th>-->
<!--                  <td mat-cell *matCellDef="let row">-->
<!--                    <div class="status-cell">-->
<!--                      <ng-container *ngTemplateOutlet="remoteChangeTypeTemplate; context: { $implicit: row }"></ng-container>-->
<!--                    </div>-->
<!--                  </td>-->
<!--                </ng-container>-->

                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                    <div class="element-detail" [@detailExpand]="row == displayedColumns ? 'expanded' : 'collapsed'">
                      <div class="element-description">
                        <div style="height: 100px; background-color: red">
                          <b>{{row.ID}}</b>:
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [style.background-color]="getRowBackgroundColor(row)"  [cdkDetailRow]="row" [cdkDetailRowTpl]="tpl"></tr>
              </table>

              <ng-template #tpl let-element>
                <tr class="mat-row detail-row" style="overflow: hidden">
                  <td colspan="9">
                    <ng-container *ngTemplateOutlet="detailsDisplayedTemplate; context: { $implicit: element }"></ng-container>
                  </td>
                </tr>
              </ng-template>

              <div *ngIf="!dataSource?.data?.length" class="no-data">
                <span i18n="@@No products Found">No products found.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
